module.exports = __webpack_public_path__ + "740cc5c968d4eb3a6ca4de9efafc75d0.png";